import { createSlotDOMElement, calculateSlotMarginAndWidth, setSlotMarginAndWidth, createSections, initSectionClickHandler } from './summary_dws_slot_render_helpers';
import { getSlotToDate } from './slot_helpers';
import { dateFromSecondsTimestamp, createStartAndEndDatesFromArray, timespansOverlap, timestampSecsFromDate, roundTwoDecimals } from './common';
import { initSectionDraw, initSectionDrawOnSlot } from './summary_dws_draw';
import { initSlotDraw } from './summary_dws_draw_slot'
import { getCanEdit, hideDataLoadingMsg, getUseShiftBorders } from './summary_dws';
import { initResizable, initResizableOnSlot } from './summary_dws_resize';
import { initDrag, initDroppableOnSlot } from './summary_dws_drag';
import { initTemplateSectionDrag, initSectionDrag } from './summary_dws_section_drag';
import { initSectionResizable, initResizableOnSection } from './summary_dws_resize_section';
import { initDroppableOnSection } from './summary_dws_section_drag';
import { initFunctionRows } from './summary_lib';
import { initTemplateRoleDrag } from './summary_dws_role_drag';

import { RoleStore } from '../store/v1/roleStore';
import { ShiftStore } from '../store/v1/shiftStore';
import { EmploymentShiftTableStats } from '../employmentShiftTable/employmentShiftTableStats';
import * as shiftParser from '../legacy/parser/shiftParser';
import * as branchParser from '../legacy/parser/branchParser';
import * as roleParser from '../legacy/parser/roleParser';
import * as employmentParser from '../legacy/parser/employmentParser';
import { getUrlParam, dateFromString, toOplusTime, fromOplusTime, yearMonthDateString } from "../common/common";
import periodTypes from "../table/v1/periodTypes";
import viewTypes from '../table/v1/viewTypes';
import { MeStore } from "../store/v1/meStore";
import { BranchStore } from "../store/v1/branchStore";
import { calcEndDate, calcStartDate, makeTableDates, truncate, endDateForPeriod } from "../table/v1/table";
import { EmploymentStore } from '../store/v1/employmentStore';
import { mergeLinkedShifts, repeatShiftsFromTemplate } from '../employmentShiftTable/employmentShiftTable';
import { DateTime } from 'luxon';

import { User } from '../model/v1/user';
import { BranchSettings } from '../model/v1/branchSettings';
import { getRoleSectionTemplates } from '../requests/roleSectionTemplateRequest';
import { getRoleCountByIdAndDate, setRoleCountTextColor } from './summary_common';

const roleSectionRequiredMap = {};
// Deprecated. Please use table package.
let tableStartDate, tableEndDate;

export function resizeSlotDOMElementsForUser(userId) {
  const slots = [];
  $(`.slots-overlay[data-user='${userId}']`).find(".slot").each(function(i, slotEl) {
    slots.push(SlotMap[$(slotEl).data("id")]);
  });
  const overlayRows = calculateOverlayRows(slots);
  setSlotElementsWidthAndMargins(overlayRows, "slot");
}

export function handleNewSlotInTable(slot, canEdit, username) {
  const useShiftBorders = getUseShiftBorders();
  const newEl = createSlotDOMElement(slot, canEdit, dateFromSecondsTimestamp(slot.ToUnix) > tableEndDate, username, useShiftBorders, roleStore);
  const slotsOverlay = $(`.slots-overlay[data-user='${slot.UserID}']`);
  slotsOverlay.append(newEl);

  resizeSlotDOMElementsForUser(slot.UserID);

  initDroppableOnSlot(slot);
  initResizableOnSlot(slot);
  initResizableOnSection(slot);
  initSectionDrawOnSlot(slot);
  initDroppableOnSection(slot);
  initSectionClickHandler(slot);
}

//calculateOverlayRows will place slots or sections, starting with least From to maximum From, in as few rows as possible where From times don't overlap with To times. It will force move linked morning slots to be rendered after their evening slots.
export function calculateOverlayRows(slots) {
  const rows = [];
  slots.forEach((slot) => {
    //If the evening slot is present, the morning slot in a linked pair will have already been placed immediately after the evening slot, so we return early.
    if (slot.LinkPrev && slots.findIndex(s => s.ID == slot.LinkPrev) > -1) {
      return;
    }
    const from = dateFromSecondsTimestamp(slot.FromUnix);

    const curRow = rows[rows.length - 1];
    if (!curRow || from < getSlotToDate(curRow[curRow.length - 1])) {
      // If From is less than To of the previous slot element, than we need to make a new row in the overlay.
      rows.push([slot]);
    } else {
      // Else we can put it in the same flex row
      curRow.push(slot);
    }
    if (slot.LinkNext) {
      const index = slots.findIndex(s => s.ID == slot.LinkNext);
      if (index > -1) {
        rows[rows.length - 1].push(slots[index]);
      }
    }
    return;
  });
  return rows;
}

//moveMorningLinkSlotToAfterEveningLinkSlot will clone the morning slot, remove it, and then insert it after the evening slot in the document flow.
function moveMorningLinkSlotToAfterEveningLinkSlot(eveningSlot) {
  const linkedSlotDOM = $(`#slot-${eveningSlot.LinkNext}`).clone(true);
  $(`#slot-${eveningSlot.LinkNext}`).remove();
  $(linkedSlotDOM).insertAfter(`#slot-${eveningSlot.ID}`);
}

//setSlotElementsWidthAndMargins takes the rows calculated by calculateOverlayRows and calls helper functions to calculate and set widths and margins of slot and section elements.
function setSlotElementsWidthAndMargins(rows, type, dates) {
  rows.forEach(function(row) {
    let slotSiblingLeft, slotSiblingRight;
    row.forEach(function(slot, i) {
      // Assume we are setting width and margin of a slot in comparison to table
      const parentDates = {
        from: dates ? dates.startDate : tableStartDate,
        to: dates ? dates.endDate : tableEndDate,
      };

      if (slot.SectionParent) {
        // If setting width and margin of a section, then calculate width and margin in comparison to parent slot
        let parentSlot = SlotMap[slot.SectionParent];
        // If we cannot find the section parent, this indicates bad data in the form of a section not pointing to its parent or pointing to a non-existing parent.
        if (!parentSlot) {
          // Remove the orphaned section from the DOM
          // TODO: handle gracefully
          $(`#slot-${slot.ID}`).remove();
          return;
        }

        const parentSlotFrom = dateFromSecondsTimestamp(parentSlot.FromUnix);
        const parentSlotTo = getSlotToDate(parentSlot);
        parentDates.from = new Date(Math.max(parentSlotFrom, parentDates.from));
        parentDates.to = new Date(Math.min(parentSlotTo, parentDates.to))
      }
      // If slot has another slot to its right, pass the sibling so we can calculate margins properly.
      if (row[i + 1]) {
        slotSiblingRight = row[i + 1];
        if (slot.LinkNext) {
          // Force reorder DOM elements so that a morning linked slot is immediately after its evening linked slot.
          moveMorningLinkSlotToAfterEveningLinkSlot(slot);
        }
      } else {
        slotSiblingRight = null;
      }
      const {relativeMarginLeft, relativeSlotWidth, relativeMarginRight } = calculateSlotMarginAndWidth(
        {
          from: dateFromSecondsTimestamp(slot.FromUnix),
          to: getSlotToDate(slot)
        },
        parentDates,
        slotSiblingLeft,
        slotSiblingRight,
      );

      const selector = `.${type}[data-id='${slot.ID}']`;

      setSlotMarginAndWidth(selector, relativeMarginLeft, relativeSlotWidth, relativeMarginRight);

      // If there is a following slot in the same row, save slot as left sibling for next slot's margin calculations.
      if (row[i + 1]) {
        slotSiblingLeft = slot;
      } else {
        slotSiblingLeft = null;
      }

      const slotEl = $(selector);
      // TODO: once we return SectionSlots after an edit, we should use slot.SectionSlots here
      if (slot.Sections) {
        // Calculate margin and width for sections if the slot has any before moving to next slot.
        const sections = [];
        slot.Sections.forEach((sectionId) => {
          const section = SlotMap[sectionId];
          if (section && timespansOverlap(dateFromSecondsTimestamp(slot.FromUnix), getSlotToDate(slot), dateFromSecondsTimestamp(section.FromUnix), getSlotToDate(section))) {
            sections.push(section);
          }
        });
        const overlayRows = calculateOverlayRows(sections);
        setSlotElementsWidthAndMargins(overlayRows, "section", dates);
      }
    })
  })
}

let nameCellUserResized = false;

//setNameCellWidths will select all of the name cells and resize them to the max width of all of names. It will not exceed maxAllowableWidth in pixels.
function setNameCellWidths() {
  if (nameCellUserResized) return;
  const nameCells = [...$(".grid-body-name-cell")];
  let maxNameWidth = 0;
  nameCells.forEach(cell => {
    const c = $(cell);
    const width = c.find("p")[0].offsetWidth;
    if ( width > maxNameWidth) {
      maxNameWidth = width;
    }
  });
  // Add padding to avoid text wrapping
  maxNameWidth += 15;
  // Our name cells will never be wider than maxAllowableWidth.
  const maxAllowableWidth = 120;
  const width = Math.min(maxNameWidth, maxAllowableWidth);
  $(".leftmost-cell").each((i, cell) => {
    const c = $(cell);
    c.css("width", `${width}px`);
  });
};

function setAllLeftmostCellWidths(width) {
  document.querySelectorAll('.leftmost-cell').forEach(cell => {
    cell.style.width = `${width}px`;
  });
}

const LEFTCOL_WIDTH_KEY = 'summary_leftcol_width';

function initDailyColResize() {
  const gridBody = document.querySelector('.grid-body');
  if (!gridBody) return;

  const saved = localStorage.getItem(LEFTCOL_WIDTH_KEY);
  if (saved) {
    nameCellUserResized = true;
    setAllLeftmostCellWidths(parseFloat(saved));
  }

  function tryStartDailyResize(e, clientX, clientY, hitZone, showIndicator) {
    const handle = e.target.closest('.col-resize-handle');
    const cell = e.target.closest('.leftmost-cell');
    if (!handle && !cell) return;
    if (!handle) {
      const rect = cell.getBoundingClientRect();
      if (clientX < rect.right - hitZone) return;
    }

    e.preventDefault();
    const refCell = handle ? handle.closest('.leftmost-cell') : cell;
    const startX = clientX;
    const startWidth = parseFloat(getComputedStyle(refCell).width);
    const startRight = refCell.getBoundingClientRect().right;

    let indicator = null;
    if (showIndicator) {
      indicator = document.createElement('div');
      indicator.style.cssText = `position:fixed;pointer-events:none;z-index:9999;top:${clientY - 8}px;left:${startRight - 8}px;`;
      indicator.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="2" cy="2" r="2" fill="#5F6B71"/><circle cx="8" cy="2" r="2" fill="#5F6B71"/><circle cx="14" cy="2" r="2" fill="#5F6B71"/><circle cx="2" cy="8" r="2" fill="#5F6B71"/><circle cx="8" cy="8" r="2" fill="#5F6B71"/><circle cx="14" cy="8" r="2" fill="#5F6B71"/><circle cx="2" cy="14" r="2" fill="#5F6B71"/><circle cx="8" cy="14" r="2" fill="#5F6B71"/><circle cx="14" cy="14" r="2" fill="#5F6B71"/></svg>`;
      document.body.appendChild(indicator);
    }

    let lastWidth = startWidth;

    document.querySelectorAll('.leftmost-cell').forEach(cell => { cell.style.borderRight = '2px solid #b1babe'; });

    function updateIndicatorX(newWidth) {
      if (indicator) indicator.style.left = (startRight + (newWidth - startWidth) - 8) + 'px';
    }

    function onMouseMove(e) {
      lastWidth = Math.max(100, startWidth + (e.clientX - startX));
      setAllLeftmostCellWidths(lastWidth);
      updateIndicatorX(lastWidth);
    }
    function onTouchMove(e) {
      e.preventDefault();
      lastWidth = Math.max(100, startWidth + (e.touches[0].clientX - startX));
      setAllLeftmostCellWidths(lastWidth);
      updateIndicatorX(lastWidth);
    }
    function cleanup() {
      nameCellUserResized = true;
      localStorage.setItem(LEFTCOL_WIDTH_KEY, lastWidth);
      document.querySelectorAll('.leftmost-cell').forEach(cell => { cell.style.borderRight = ''; });
      if (indicator) indicator.remove();
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', cleanup);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', cleanup);
    }

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', cleanup);
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', cleanup);
  }

  gridBody.addEventListener('mousedown', (e) => tryStartDailyResize(e, e.clientX, e.clientY, 16, false));
  gridBody.addEventListener('touchstart', (e) => tryStartDailyResize(e, e.touches[0].clientX, e.touches[0].clientY, 16, true), { passive: false });
}

//initializeSlotDOMElements will find all of the slot overlays and will call helper functions to set width and margins for all slots and sections
// This function is used by the dws print page and dates param is exclusively for the print page as well.
export function initializeSlotDOMElements(dates) {
  $(".slots-overlay").each(function(i, row) {
    const slots = [];
    $(row).find(".slot").each(function(i, slotEl) {
      const slot = SlotMap[$(slotEl).data("id")];
      slots.push(slot);
    });

    // This is a bandaid fix for getting sections to appear in the correct order on the DOM since they are unsorted in the BE data
    slots.forEach(slot => {
      $(`#slot-${slot.ID}`).find(".sections-overlay").html(createSections(slot, roleStore));
      initSectionClickHandler(slot)
    })
    const overlayRows = calculateOverlayRows(slots);
    setSlotElementsWidthAndMargins(overlayRows, "slot", dates);
  });
}

export function getTableStartDate() {
  return tableStartDate;
}

export function getTableEndDate() {
  return tableEndDate;
}

// forceFindSectionParent is a bandaid fix for the known issue where slots extracted from repeat sequences have sections that point to the incorrect parent.
// forceFindSectionParent will look through all slots in the SlotMap and will return a slot if that slot's Sections array contains the passed section's id.
function forceFindSectionParent(section) {
  let parentSlot;
  Object.keys(SlotMap).forEach(slotId => {
    if (parentSlot) {
      return;
    }
    const slot = SlotMap[slotId];

    if (slot.Sections) {
      slot.Sections.forEach(sectionId => {
        if (sectionId == section.ID) {
          parentSlot = slot;
          return;
        }
      })
    }
  })
  return parentSlot;
}

// STATS
// Global stores and refs to support render / accept shift data from template
// Should be in a table component in the future
export let tableDates;
export let roleStore;
let summaryStats;
let shiftStore;
let meStore;
let branchStore;

function initStats(roleStore, employmentStore, shiftStore, meStore, dates, period, timeZone) {
  const options = {
    onlyCountFirstPeriod: false,
    onlyCountFirstRole: false,
    onlyCountFirstTransport: true,
    shouldIgnoreRest: true,
  };
  const summaryStats = new EmploymentShiftTableStats(roleStore, employmentStore, shiftStore, meStore, dates, period, timeZone, options);

  return summaryStats;
}

export function renderAllColumns() {
  tableDates.forEach(d => {
    const column = summaryStats.getColumnStats(d.index()).getData();
    const date = d.getDate();
    renderStatsColumn(toOplusTime(date), column);
  })
}

function handleSlotChange(rawSlot, repeatTimeZone) {
  if (rawSlot.SectionParent) {
    return;
  }

  let shift;

  if (rawSlot.Repeat) {
    shift = shiftParser.parseRepeatShiftTemplateOplusTimeRaw(rawSlot, repeatTimeZone);
    const repeatShifts = repeatShiftsFromTemplate(tableDates[0].getDate(), tableDates[tableDates.length - 1].getEnd(), shift, "Asia/Tokyo", "Asia/Tokyo");
    repeatShifts.forEach(r => {
      shiftStore.add(r);
      summaryStats.handleShiftChange(r)
    })
  } else if (rawSlot.LinkPrev) {
    shift = shiftParser.parseMorningShiftRaw(rawSlot)
  } else if (rawSlot.LinkNext) {
    shift = shiftParser.parseNightShiftRaw(rawSlot)
  } else if (rawSlot.IsTemplate) {
    // not implemented
    return;
  } else {
    shift = shiftParser.parseShiftRaw(rawSlot);
  }

  if (shift.isClone(meStore.getActiveBranchId()) || shift.isShiftTemplate() || shift.isRepeatShiftTemplate()) {
    return;
  }

  shiftStore.add(shift);
}

// Stats requires special handling for linked slots.
export function handleLinkedSlotsStats(rawSlots) {
  if (!rawSlots && !rawSlots.length) {
    return;
  }

  let prev = shiftStore.byId(rawSlots[0].ID.toString());
  if (prev && prev.isLinkedShift()) {
    let night, morning;
    if (prev.isMorningShift()) {
      morning = prev;
      night = shiftStore.byId(prev.getLinkedId());
    } else {
      night = prev;
      morning = shiftStore.byId(prev.getLinkedId());
    }
    if (morning && night) {
      prev = mergeLinkedShifts(morning, night);
    }
  }

  // Add to store
  rawSlots.forEach(s => {
    handleSlotChange(s, branchStore.byId(meStore.getActiveBranchId())?.timeZone);
  })

  const options = {
    prevShift: prev,
  }

  // Special treatment for linked and calc stats
  rawSlots.forEach(s => {
    let shift = shiftStore.byId(s.ID.toString());
    if (!shift) {
      return;
    }
    if (shift.isLinkedShift()) {
      let night, morning;
      if (shift.isMorningShift()) {
        morning = shift;
        night = shiftStore.byId(shift.getLinkedId());
      } else {
        night = shift;
        morning = shiftStore.byId(shift.getLinkedId());
      }
      if (morning && night) {
        // Only calc stats for merged shift once, if both shift are in view.
        if (morning.getId() == shift.getId()) {
          return;
        }
        shift = mergeLinkedShifts(morning, night);
        options.countAllPeriods = true;
      }
    }
    handleSlotChangeStats(shift, options);
  })

  // Render
  renderAllColumns();
}

function handleSlotChangeStats(shift, options = {}) {
  if (!shift) {
    return;
  }

  summaryStats.handleShiftChange(shift, options);
}

// Interface for template
export function handleRawSlotChange(rawSlot) {
  if (!rawSlot || rawSlot.LinkNext || rawSlot.LinkPrev) {
    return;
  }
  const prev = shiftStore.byId(rawSlot.ID.toString());
  handleSlotChange(rawSlot, branchStore.byId(meStore.getActiveBranchId())?.timeZone);
  const options = {
    prevShift: prev,
  }
  handleSlotChangeStats(shiftStore.byId(rawSlot.ID.toString()), options);
  renderAllColumns();
}

//addStatsDiffToColumnAndRender adds diffs from the passed diffObj to the relevant stats field in the columnsMap and then renders the updated stat.
function renderStatsColumn(hour, column) {
  //Element IDs currently use the timestamps from the Go template, which are in seconds so we convert JS-standard ms to seconds.
  const selectorTimestamp = timestampSecsFromDate(hour);
  const dateStr = yearMonthDateString(hour, "UTC"); // To work with oplus time date strings in App, hardcode timezone.
  renderStats(`#num-worker-${selectorTimestamp}`, column.numOfWorkers);
  renderStats(`#labor-hours-${selectorTimestamp}`, roundTwoDecimals(column.laborHours, ","));
  Object.keys(column.roleCounts).forEach(roleId => {
    const role = roleStore.byId(roleId);
    if (!role || role.isOrRole() || role.isMainRole()) {
      return;
    }

    const count = column.roleCounts[roleId] || 0;
    let countText = count.toString();
    const roleCountRequired = getRoleCountByIdAndDate(App, roleId, dateStr)?.Required;

    if (count === 0 && !roleCountRequired) {
        //If the count is zero and there is no required count set, then we'll set the text back to dash mark instead of zero.
        countText = "-";
    }
    renderDwsRoleCounts(roleId, selectorTimestamp, count, countText, dateStr)
  })

  roleStore.query({ filterRoleSection: true, isRoleSection: true }).forEach(r => {
    const roleId = r.getId();
    const currentCount = column.roleSectionCounts[roleId] || 0;
    let hasCount = true;
    const {roleCountRequired, hasConflict} = getRoleSectionRequiredById(roleId, hour);
    if (currentCount === 0 && !roleCountRequired) {
      //If the count is zero and there is no required count set, then we'll set the text back to dash mark instead of zero.
      hasCount = false;
    }
    renderDwsRoleSectionCounts(roleId, selectorTimestamp, currentCount, hasCount, dateStr, roleCountRequired, hasConflict)
    if (hasConflict) {
      $(`#role-count-${roleId}-${selectorTimestamp}`).addClass("has-conflict");
      $(`#role-count-row-${roleId} .has-conflict-icon`).removeClass("d-none");
    }
    return;
  })

  roleStore.query({isMainRole: true, filterMainRole: true}).forEach(r => {
    const roleId = r.getId();
    const onlyRequiresOr = true;
    if (onlyRequiresOr) {
      const currentCount = column.orRoleCounts[roleId] || 0;
      let countText = currentCount.toString();
      const roleCountRequired = getRoleCountByIdAndDate(App, roleId, dateStr)?.Required;
      if (currentCount === 0 && !roleCountRequired) {
          //If the count is zero and there is no required count set, then we'll set the text back to dash mark instead of zero.
          countText = "-";
      };

      renderDwsRoleCounts(roleId, selectorTimestamp, currentCount, countText, dateStr)
      return;
    }
  })
}

//renderStats will render the given stat for the given hour using Jquery.
function renderStats(selector, statText) {
  $(selector).text(statText);

  if (Number(statText) === 0) {
    $(selector).addClass("text-gray");
  }
}

function renderDwsRoleCounts(roleId, selectorTimestamp, count, countText, dateStr) {
  renderStats(`#role-count-${roleId}-${selectorTimestamp}-count`, countText);
  setRoleCountTextColor(count, roleId, dateStr, `#role-count-${roleId}-${selectorTimestamp}-text`, App);
  //TODO: refactor setRoleCountTextColor to not remove all classes, then remove this class add
  $(`#role-count-${roleId}-${selectorTimestamp}-text`).addClass('stats-cell-text');
}

// renderDwsRoleSectionCounts will override the required role count text, it will override the whole text format "01 / 10"
function renderDwsRoleSectionCounts(roleSectionId, selectorTimestamp, count, hasCount, dateStr, requiredCount) {
  const countTextEl = `#role-count-${roleSectionId}-${selectorTimestamp}-text`;
  let roleSectionCountText = `${count.toString()}`
  if (requiredCount) {
    roleSectionCountText += `/${requiredCount}`
  }
  if (!hasCount) {
    roleSectionCountText = "0/0";
  }
  renderStats(countTextEl, roleSectionCountText);
  setRoleCountTextColor(count, roleSectionId, dateStr, countTextEl, App, requiredCount);
}

export function handleSlotDelete(rawSlot) {
  if (!rawSlot) {
    return;
  }

  let shift = shiftStore.byId(rawSlot.ID.toString());
  if (rawSlot.Repeat) {
    // For now, we get date of the repeat from the modal to delete only the "extracted" shift.
    // In the future, slot modal should pass the feId so we don't need to query.
    const oplusTimeUnix = SlotModal.data?.dateUnix;
    const oplusTimeDate = dateFromSecondsTimestamp(oplusTimeUnix);
    const d = fromOplusTime(oplusTimeDate);
    const max = endDateForPeriod(d, periodTypes.DAY, "Asia/Tokyo");
    const res = shiftStore.query({repeatTemplateId: rawSlot.ID, startDateMin: d, startDateMax: max});
    shift = res[0];
  }

  if (!shift) {
    return;
  }

  let statsShift = shift;

  const options = {
    isDelete: true,
  }

  if (shift.isLinkedShift()) {
    let night, morning;
    if (shift.isMorningShift()) {
      morning = shift;
      night = shiftStore.byId(shift.getLinkedId());
    } else {
      night = shift;
      morning = shiftStore.byId(shift.getLinkedId());
    }
    if (morning && night) {
      // Only calc stats for merged shift once, if both shift are in view.
      if (morning.getId() == shift.getId()) {
        return;
      }
      statsShift = mergeLinkedShifts(morning, night);
      options.countAllPeriods = true;
    }
  }

  summaryStats.handleShiftChange(statsShift, options);
  renderAllColumns();
  // delete from store
  if (statsShift.isMergedShift()) {
    shiftStore.delete(statsShift.getMorningShiftId());
    shiftStore.delete(statsShift.getNightShiftId());
    return;
  }

  shiftStore.delete(shift.getId());
}

// END STATS

//initTable will set global date variables needed for calculations and call other initialization functions
export async function initTable(props) {
  // Deprecated dates built off of BE oplus time objects.
  // See below for current implementation
  initRoleStore(props);
  const {startDate: startOplusTime, endDate: endOplusTime} = createStartAndEndDatesFromArray(props.pipelineDates, true);
  tableStartDate = startOplusTime;
  tableEndDate = endOplusTime;
  initializeSlotDOMElements();
  setNameCellWidths();
  initDailyColResize();
  if (getCanEdit()) {
    // Add click event listeners to dropzone cells to open slot modal or place template slots
    $(".dropzones").on("click", function(e){
      const target = $(e.target);
      const addButton = $(`.add-button[data-timestamp="${target.data('timestamp')}"][data-user="${target.data('user')}"]`);

      // Show Color to simulate a tap.
      const originalColor = $(this).css("background-color")
      $(this).css({"background-color":"#5755d9"});
      var elm = $(this);
      setTimeout( function(){
        elm.css("background-color",originalColor);
      }, 200);

      addButton.click();
    });
    initResizable();
    initDrag();
    initSectionDraw();
    initSlotDraw();
    initSectionResizable();
    initSectionDrag(SlotMap, App.roles);
    initTemplateRoleDrag(SlotMap, App.roles);
    initTemplateSectionDrag(SlotMap, App.roles);
  }
  initDailyStats(props);
  if (props.pipelineCanEdit) { // TODO: use meStore to determine perm level
    const activeBranch = branchStore.byId(meStore.getActiveBranchId());
    if (!activeBranch) {
      return;
    }
    await initFunctionRows(props.legacyPlans, props.pipelineActiveBranchSettings.PlanEquationValue, activeBranch, tableDates);
  }
  await setRoleSectionDataToMap(tableStartDate);
  renderAllColumns();

  // Remove loading from rows that are computed on FE
  $('.flex-row.loading').removeClass('loading');
  hideDataLoadingMsg();
}

function initRoleStore(props) {
  if (roleStore) return;

  roleStore = new RoleStore();

  props.roles.forEach(raw => {
    // parse as main role
    if (props.orRolesMap.mainRolesMap[raw.ID]) {
      const subs = props.orRolesMap.mainRolesMap[raw.ID];
      const mainRole = roleParser.parseMainRoleFromRaw(raw, subs);
      roleStore.add(mainRole);
      return;
    }

    // parse as sub role
    if (props.orRolesMap.subRolesMap[raw.ID]) {
      const mainRoleId = props.orRolesMap.subRolesMap[raw.ID];
      const subRole = roleParser.parseOrRoleFromRaw(raw, mainRoleId);
      roleStore.add(subRole);
      return
    }

    const role = roleParser.parseFromRaw(raw);

    roleStore.add(role);
  })
}

/* ----------------------------------------------------

ATTENTION:
This is used by the print page as well,
any changes to the below function will very likely break the print page.

-------------------------------------------------------
*/
export function initDailyStats(props) {

  branchStore = new BranchStore();
  const branch = branchParser.parseFromRaw(props.pipelineActiveCompany);

  branchStore.add(branch);
  const user = new User({id: props.activeUserID});
  meStore = new MeStore({user});
  meStore.setActiveBranchId(branch.getId())

  // keep initRoleStore here even though initTable has alrdy called it
  // this is to keep it similar to old structure, as specified in the comments above to not break the print page
  initRoleStore(props); 

  const employmentStore = new EmploymentStore();
  // props is confusingly called users, but are actually extracts of company users
  props.users.forEach(rawEmployment => {
    const employment = employmentParser.parseFromRaw(rawEmployment, branch.getOriginalId());
    employmentStore.add(employment);
  })

  // To work "properly" with oplus time, hardcode time zone to JST
  // Eventually, this will be a user setting and/or guess
  const localTimeZone = "Asia/Tokyo";
  const activeBranch = branchStore.byId(meStore.activeBranchId);
  const viewType = viewTypes.DAY;
  const branchTimeZone = activeBranch.getTimeZone();
  const branchSettingsReqParam = {
    timeZone: localTimeZone
  }
  const branchSettingsOptParam = {
    summaryDayStart: props.pipelineActiveBranchSettings.SummaryDayStart,
    summaryDayEnd:  props.pipelineActiveBranchSettings.SummaryDayEnd
  }
  const branchSettings = new BranchSettings(branchSettingsReqParam, branchSettingsOptParam);

  activeBranch.setSettings(branchSettings)

  let dateStr = getUrlParam("date");
  // To work with oplus time, ensure date is JST time.
  const luxonDate = DateTime.now().setZone(localTimeZone);
  let date = luxonDate.toJSDate();
  date = truncate(date, periodTypes.HOUR, localTimeZone);

  if (dateStr) {
    date = dateFromString(dateStr, localTimeZone); // Hardcode to support oplus time FE
  }

  try {
    const startDate = calcStartDate(date, viewType, localTimeZone, {dayStart: activeBranch.getDayStart(), branchTimeZone});
    const endDate = calcEndDate(startDate, viewType, localTimeZone, {dayEnd: activeBranch.getDayEnd(), branchTimeZone});
    tableDates = makeTableDates(startDate, endDate, periodTypes.HOUR, localTimeZone);
  } catch (e) {
    alert(e.message);
    return;
  }
  shiftStore = new ShiftStore();

  summaryStats = initStats(roleStore, employmentStore, shiftStore, meStore, tableDates, periodTypes.HOUR, localTimeZone);
  Object.keys(SlotMap).forEach(slotId => {
    const rawSlot = SlotMap[slotId];

    handleSlotChange(rawSlot, activeBranch.getTimeZone());
  });

  for (const slotId in shiftStore.data) {
    const s  = shiftStore.byId(slotId);
    const options = {};
    let shift = s;
    if (shift.isLinkedShift()) {
      let night, morning;
      if (shift.isMorningShift()) {
        morning = shift;
        night = shiftStore.byId(shift.getLinkedId());
      } else {
        night = shift;
        morning = shiftStore.byId(shift.getLinkedId());
      }
      if (morning && night) {
        // Only calc stats for merged shift once, if both shift are in view.
        if (morning.getId() == shift.getId()) {
          continue;
        }
        shift = mergeLinkedShifts(morning, night);
        options.countAllPeriods = true;
      }
    }
    handleSlotChangeStats(shift, options);
  }

}

async function getRoleSectionRequiredCount(startDate = "", endDate = "") {
  const payload = {};
  payload.branchId = meStore.getActiveBranchId();
  if (startDate) {
    payload.startDate = yearMonthDateString(startDate, "UTC");
  }
  if (endDate) {
    payload.endDate = yearMonthDateString(endDate, "UTC");
  }
  try {
    const templates = await getRoleSectionTemplates(parseInt(meStore.getActiveUserId()), payload);
    return templates;
  } catch (err) {
    throw err;
  }
}

async function setRoleSectionDataToMap(startOplusTime) {
  try {
    // Use same date as startTime for now, we will change this if we support overnight templates
    const endDate = new Date(startOplusTime);

    const templates = await getRoleSectionRequiredCount(startOplusTime, endDate);
    templates.forEach(t => {
      if (!roleSectionRequiredMap[t.roleSectionId]) {
        roleSectionRequiredMap[t.roleSectionId] = {}
      }
      roleSectionRequiredMap[t.roleSectionId][t.id] = [];

      t.getRequiredTimeSlots().forEach(ts => {
        roleSectionRequiredMap[t.roleSectionId][t.id].push({
          required: ts.requiredCount,
          startTime: ts.startTime,
          endTime: ts.endTime,
        })
      })
    })
  } catch (err) {
    throw err
  }
}

function convertToMinutes(time) {
  return time.getHours() * 60 + time.getMinutes();
}

function getRoleSectionRequiredById(roleSectionId, hour) {
  const out = {
    roleCountRequired: 0,
    hasConflict: false,
  }
  if (!roleSectionRequiredMap[roleSectionId]) {
    return out;
  }

  let isOccupied = false;
  Object.values(roleSectionRequiredMap[roleSectionId]).forEach(template => {
    if (!template) {
      return;
    }
    template.forEach(t => {
      const templateStartTime = convertToMinutes(t.startTime);
      const templateEndTime = convertToMinutes(t.endTime);
      const tableTime = convertToMinutes(fromOplusTime(hour));

      if (templateStartTime <= tableTime && templateEndTime > tableTime) {
        if (isOccupied) {
          out.hasConflict = true;
          return;
        }
        out.roleCountRequired = t.required;
        isOccupied = true;
      }
    })
  })

  return out;
}
